export const SELLER_TYPE_CLASS = {
  Individual: "bg-sky-500 text-white",
  Business: "bg-amber-500 text-white",
  Breeder: "bg-purple-600 text-white",
  Shelter: "bg-rose-500 text-white",
  Rescue: "bg-rose-500 text-white",
};
export const sellerTypeClass = (t) => SELLER_TYPE_CLASS[t] || "bg-slate-500 text-white";
export const VERIFIED_CLASS = { seller: "bg-emerald-600", business: "bg-amber-500", breeder: "bg-purple-600" };
